














































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateItemDetail from "./createItemDetail.vue";
import EditItemDetail from "./editItemDetail.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";
import ClassificationManagement from "@/views/basedatas/Items/items.vue";

class PageUserRequest extends PageRequest {
  keyword: string;
  itemid: string;
}

@Component({
  components: { CreateItemDetail, EditItemDetail, ClassificationManagement },
})
export default class ItemDetail extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  dataitems() {
    this.itemsModalShow = true;
  }
  edit() {
    this.editModalShow = true;
  }

  pagerequest: PageUserRequest = new PageUserRequest();
  creationTime: Date[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  treedata: [] = [];
  itemId: string = "0";
  splitnum: number = 0.15;
  itemsModalShow: boolean = false;//数据字典类型管理

  get list() {
    return this.$store.state.itemdetail.list;
  }
  get loading() {
    return this.$store.state.itemdetail.loading;
  }
  async itemtree() {
    await this.$store
      .dispatch("items/getTree")
      .then((val) => {
        this.treedata = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  create() {
    if (this.itemId == "0") {
      this.$Modal.warning({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("DataItems"),
      });
    } else {
      this.createModalShow = true;
    }
  }
  pageChange(page: number) {
    this.$store.commit("itemdetail/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("itemdetail/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    this.pagerequest.sorting = key.key + " " + key.order;
    this.getpage();
  }
  //树形结构节点
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.itemId = item[0].id;
    }
    this.$store.commit("itemdetail/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("itemdetail/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.itemid = this.itemId;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "itemdetail/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.itemdetail.pageSize;
  }
  get totalCount() {
    return this.$store.state.itemdetail.totalCount;
  }
  get currentPage() {
    return this.$store.state.itemdetail.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Name"),
      key: "name",
      sortable: true,
    },
    {
      title: this.L("FirstNode"),
      key: "itemName",
      sortable: true,
    },
    {
      title: this.L("Encode"),
      key: "enCode",
      sortable: true,
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      sortable: true,
    },
    {
      title: this.L("IsEnable"),
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
        );
      },
    },
    {
      title: this.L("Id"),
      key: "id",
      sortable: true,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('dataitemdetailDel');
        let edit = this.checkButtonAuth('dataitemdetailEdit');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("itemdetail/edit", params.row);
                  //console.log(params.row)
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "itemdetail/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
    this.itemtree();
  }
}
